import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

// Define keyframes for wiggle animation
const WiggleKeyframes = () => (
  <style jsx global>{`
    @keyframes wiggle {
      0%, 100% { transform: rotate(0deg); }
      25% { transform: rotate(-5deg); }
      50% { transform: rotate(5deg); }
      75% { transform: rotate(-5deg); }
    }
    
    .wiggle-animation {
      animation: wiggle 0.5s ease-in-out;
    }
  `}</style>
);

export default function OpenCart({
  className,
  quantity
}: {
  className?: string;
  quantity?: number;
}) {
  const [isWiggling, setIsWiggling] = useState(false);
  
  useEffect(() => {
    // Only trigger wiggle animation when cart quantity changes and is not zero
    if (quantity && quantity > 0) {
      setIsWiggling(true);
      const timer = setTimeout(() => {
        setIsWiggling(false);
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, [quantity]);

  return (
    <>
      <WiggleKeyframes />
      <div className={clsx(
        "relative flex h-11 w-11 items-center justify-center rounded-md border border-neutral-700 text-white transition-colors hover:bg-neutral-800",
        isWiggling && "wiggle-animation"
      )}>
        <ShoppingCartIcon
          className={clsx(
            'h-4 transition-all ease-in-out hover:scale-110',
            className
          )}
        />

        {quantity ? (
          <div className="absolute right-0 top-0 -mr-2 -mt-2 h-4 w-4 rounded-sm bg-[#F1EFEC] text-[11px] font-medium text-black flex items-center justify-center">
            {quantity}
          </div>
        ) : null}
      </div>
    </>
  );
}
